import { IPlayerProps, Player } from '@lottiefiles/react-lottie-player';
import * as confetti from 'assets/js/animations/confetti-sides.json';
import { twMerge } from 'tailwind-merge';

interface IRequiredChecklistGenericConfetti extends Omit<IPlayerProps, 'src'> {}
const RequiredChecklistGenericConfetti = ({
    className,
    ...rest
}: IRequiredChecklistGenericConfetti) => {
    return (
        <div aria-hidden className="pointer-events-none absolute left-0 top-0 h-full w-full">
            <Player
                aria-hidden
                autoplay
                rendererSettings={{ preserveAspectRatio: 'xMidYMin slice' }}
                src={JSON.stringify(confetti)}
                className={twMerge('absolute h-full w-full', className)}
                {...rest}
            />
        </div>
    );
};

export { RequiredChecklistGenericConfetti };
